(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[159],{

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "2Ufl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTitle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var LineTitle = function LineTitle(_ref) {
  var className = _ref.className,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className"]);

  return __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mb-20', className),
    theme: "title-brand-n1"
  }));
};

/***/ }),

/***/ "3OwS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("gz38"),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__("I2LH"),
    UnmountClosed = _require2.UnmountClosed; // Default export


module.exports = UnmountClosed; // Extra "named exports"

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

/***/ }),

/***/ "A3qt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.themes.js



var themes = {
  "default": function _default(_ref) {
    var titleColor = _ref.titleColor,
        subtitleColor = _ref.subtitleColor;
    return {
      thRoot: 'bg-darkGrey h-full isolate overflow-hidden relative rounded-12',
      thHeader: 'flex absolute justify-center items-start mt-20 text-center top-0 w-full',
      thImage: 'opacity-75 transition-transform duration-250 ease-in transform hover:scale-105',
      thHeaderItem: function thHeaderItem(_ref2) {
        var _ref2$textColor = _ref2.textColor,
            textColor = _ref2$textColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref2$textColor,
            _ref2$backgroundColor = _ref2.backgroundColor,
            backgroundColor = _ref2$backgroundColor === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref2$backgroundColor;
        return classnames_default()("bg-".concat(backgroundColor), 'font-sans font-bold leading-1 max-w-1/2 m-0 mx-5 px-10 py-5 rounded-pill text-12', "text-".concat(textColor));
      },
      thTitle: classnames_default()('font-brand font-bold leading-tight mb-10 text-22 text-center', Object(defineProperty["a" /* default */])({}, "text-".concat(titleColor || colors["a" /* COLORS */].WHITE), true)),
      thSubTitle: classnames_default()('m-0 pb-15 text-center text-14', Object(defineProperty["a" /* default */])({}, "text-".concat(subtitleColor || colors["a" /* COLORS */].WHITE), true)),
      thFooter: 'absolute bottom-0 p-10 pb-20 transition-transform duration-250 ease-in w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var OfferPush_OfferPush = function OfferPush(_ref) {
  var _tag$, _tag$2;

  var countdown = _ref.countdown,
      id = _ref.id,
      link = _ref.link,
      mediaUrl = _ref.mediaUrl,
      subTitle = _ref.subTitle,
      tag = _ref.tag,
      _ref$theming = _ref.theming,
      titleColor = _ref$theming.titleColor,
      subtitleColor = _ref$theming.subtitleColor,
      title = _ref.title,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 / 3 : _ref$ratioDisplay;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';

  var _themes$default = themes.default({
    titleColor: titleColor,
    subtitleColor: subtitleColor,
    isHover: isHover
  }),
      thRoot = _themes$default.thRoot,
      thImage = _themes$default.thImage,
      thHeader = _themes$default.thHeader,
      thHeaderItem = _themes$default.thHeaderItem,
      thTitle = _themes$default.thTitle,
      thFooter = _themes$default.thFooter,
      thSubTitle = _themes$default.thSubTitle;

  var track = Object(useTracking["a" /* useTracking */])(_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: constants["k" /* OFFER_PUSH */].ACTION,
    labelGA: title,
    thumbnailList: "".concat(siteSection, "_offers"),
    thumbnailPosition: id
  }));
  var shouldDisplayOffer = !countdown.dateTimeEnd && ((_tag$ = tag[1]) === null || _tag$ === void 0 ? void 0 : _tag$.text);
  var shouldDisplayCountdown = countdown.dateTimeEnd;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  return __jsx("article", {
    className: thRoot,
    "data-testid": "offer-push-container",
    dir: isRTL ? 'rtl' : 'ltr'
  }, __jsx(DynamicLink["a" /* default */], {
    className: "block relative overflow-hidden h-full",
    "data-testid": "offer-push-".concat(id, "-link"),
    onBlur: function onBlur() {
      return setHover(false);
    },
    onClick: function onClick() {
      return track();
    },
    onFocus: function onFocus() {
      return setHover(true);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    url: link
  }, __jsx("div", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: title,
    groupKey: "offers-push",
    hasLazyLoading: true,
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["c" /* default */].XL,
    ratioDisplay: ratioDisplay
  })), __jsx("div", {
    className: thHeader
  }, ((_tag$2 = tag[0]) === null || _tag$2 === void 0 ? void 0 : _tag$2.text) && __jsx("p", {
    className: thHeaderItem(tag[0].theming, true),
    "data-testid": "offer-push-".concat(id, "-tag-first")
  }, __jsx("span", {
    className: "block pt-1 truncate"
  }, tag[0].text)), shouldDisplayCountdown && __jsx(Countdown["a" /* Countdown */], {
    bgColor: countdown.backgroundColor,
    className: "leading-1 mx-5",
    color: countdown.textColor,
    dataTestId: "offer-push-".concat(id, "-countdown"),
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds,
    theme: "offerPush"
  }), shouldDisplayOffer && __jsx("p", {
    className: thHeaderItem(tag[1].theming, false),
    "data-testid": "offer-push-".concat(id, "-tag-second")
  }, __jsx("span", {
    className: "block pt-1 truncate"
  }, tag[1].text))), __jsx("div", {
    className: thFooter
  }, title && __jsx("h3", {
    className: thTitle,
    "data-testid": "offer-push-".concat(id, "-title")
  }, title), subTitle && __jsx(lib["Collapse"], {
    isOpened: isHover
  }, __jsx("p", {
    className: thSubTitle,
    "data-testid": "offer-push-".concat(id, "-subtitle")
  }, Object(string_util["d" /* truncate */])(subTitle, 115))))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/constants.js
var image_constants = __webpack_require__("znkg");

// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/image.constants.js

var OFFER_STYLE = {
  width: '85vw',
  maxWidth: '380px'
};
var RATIO_DISPLAYS = [{
  value: 1 / 3,
  unit: image_constants["d" /* DISPLAY_REM */]
}, {
  value: 380,
  unit: 'px'
}, {
  value: 380,
  unit: 'px'
}, {
  value: 85 / 100,
  unit: image_constants["e" /* DISPLAY_VIEWPORT */]
}];
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineNarrow.jsx


var OffersPushLineNarrow_jsx = react_default.a.createElement;








var TRACKING = {
  actionGA: 'push_content_offers',
  labelGA: 'seeMore'
};
var OffersPushLineNarrow_OffersPushLineNarrow = function OffersPushLineNarrow(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;
  var track = Object(useTracking["a" /* useTracking */])(TRACKING);
  return OffersPushLineNarrow_jsx(react["Fragment"], null, !!title && OffersPushLineNarrow_jsx(LineTitle["a" /* LineTitle */], null, title), OffersPushLineNarrow_jsx("div", {
    className: "-mx-20 w-screen"
  }, OffersPushLineNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: false,
    navPosition: "center",
    nbItemsToScroll: 1,
    nextLabel: Object(i18n["h" /* t */])('common.next'),
    previousLabel: Object(i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "gap-20 px-20 lg:px-0 scrollbar-hidden scroll-x scroll-smooth",
    scrollControlsClassName: "-mx-20 lg:mx-0"
  }, columns.map(function (columnProps, index) {
    return OffersPushLineNarrow_jsx("div", {
      style: OFFER_STYLE,
      key: index
    }, OffersPushLineNarrow_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, columnProps, {
      id: index + 1,
      ratioDisplay: RATIO_DISPLAYS
    })));
  }))), seeMoreLabel && seeMoreLink && OffersPushLineNarrow_jsx(DynamicLink["a" /* default */], {
    className: "block mx-auto mt-15 text-center text-14 text-black hocus:text-black-active underline",
    onClick: function onClick() {
      return track();
    },
    url: seeMoreLink
  }, seeMoreLabel));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineLarge.jsx


var OffersPushLineLarge_jsx = react_default.a.createElement;









var OffersPushLineLarge_TRACKING = {
  actionGA: 'push_content_offers',
  labelGA: 'seeMore'
};
var OffersPushLineLarge_OffersPushLineLarge = function OffersPushLineLarge(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var track = Object(useTracking["a" /* useTracking */])(OffersPushLineLarge_TRACKING);
  return OffersPushLineLarge_jsx(react["Fragment"], null, OffersPushLineLarge_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, title && OffersPushLineLarge_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), seeMoreLabel && seeMoreLink && OffersPushLineLarge_jsx(DynamicLink["a" /* default */], {
    className: "mx-0 mt-5 text-14 text-black hocus:text-black-active underline",
    onClick: function onClick() {
      return track();
    },
    url: seeMoreLink
  }, seeMoreLabel)), OffersPushLineLarge_jsx(Slider["a" /* Slider */], {
    className: "-mx-20 lg:mx-0 w-screen lg:w-full",
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: 2,
    nextLabel: Object(i18n["h" /* t */])('common.next'),
    previousLabel: Object(i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "gap-20 px-20 lg:px-0 scrollbar-hidden scroll-x scroll-smooth",
    scrollControlsClassName: "-mx-20 lg:mx-0"
  }, columns.map(function (column, index) {
    return OffersPushLineLarge_jsx("div", {
      style: OFFER_STYLE,
      key: index
    }, OffersPushLineLarge_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, column, {
      id: index + 1,
      ratioDisplay: RATIO_DISPLAYS
    })));
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLine.jsx
var OffersPushLine_jsx = react_default.a.createElement;





var OffersPushLine_OffersPushLine = function OffersPushLine(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return OffersPushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: props.id
  }, isTablet ? OffersPushLine_jsx(OffersPushLineLarge_OffersPushLineLarge, props) : OffersPushLine_jsx(OffersPushLineNarrow_OffersPushLineNarrow, props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/offers-push/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (OffersPushLine_OffersPushLine);

/***/ }),

/***/ "I2LH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _Collapse = __webpack_require__("gz38");

var _excluded = ["isOpened"],
    _excluded2 = ["isOpened"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnmountClosed = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  var _super = _createSuper(UnmountClosed);

  function UnmountClosed(props) {
    var _this;

    _classCallCheck(this, UnmountClosed);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref) {
      var isOpened = _ref.isOpened,
          rest = _objectWithoutProperties(_ref, _excluded);

      _this.setState({
        isResting: false,
        isOpened: isOpened
      });

      var onWork = _this.props.onWork;

      if (onWork) {
        onWork(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref2) {
      var isOpened = _ref2.isOpened,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      _this.setState({
        isResting: true,
        isOpened: isOpened,
        isInitialRender: false
      });

      var onRest = _this.props.onRest;

      if (onRest) {
        onRest(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialStyle", function () {
      var _this$state = _this.state,
          isOpened = _this$state.isOpened,
          isInitialRender = _this$state.isInitialRender;

      if (isInitialRender) {
        return isOpened ? {
          height: 'auto',
          overflow: 'initial'
        } : {
          height: '0px',
          overflow: 'hidden'
        };
      }

      return {
        height: '0px',
        overflow: 'hidden'
      };
    });

    _this.state = {
      isResting: true,
      isOpened: props.isOpened,
      isInitialRender: true
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;

      if (prevProps.isOpened !== isOpened) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isResting: false,
          isOpened: isOpened,
          isInitialRender: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isResting = _this$state2.isResting,
          isOpened = _this$state2.isOpened;
      return isResting && !isOpened ? null : /*#__PURE__*/_react["default"].createElement(_Collapse.Collapse, _extends({}, this.props, {
        initialStyle: this.getInitialStyle(),
        onWork: this.onWork,
        onRest: this.onRest
      }));
    }
  }]);

  return UnmountClosed;
}(_react["default"].PureComponent);

exports.UnmountClosed = UnmountClosed;

_defineProperty(UnmountClosed, "defaultProps", {
  onWork: undefined,
  onRest: undefined
});

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "ZFcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Slider; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-5 mt-10',
    thControl: 'mx-5'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 transform -translate-y-1/2 w-full',
    thControl: 'pointer-events-auto before:absolute before:content-[""] before:h-[120px] before:right-0 before:h-[40px]',
    thControlLeft: 'transform -translate-x-1/2',
    thControlRight: 'transform translate-x-1/2',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-5',
    thControl: 'mx-5'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-5 mb-10 order-first',
    thControl: 'mx-5'
  }
};
var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND
    });
  },
  brand: function brand(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].SAFFRON
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx









var __jsx = react_default.a.createElement;






function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      scrollItemStyle = props.scrollItemStyle,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = throttle_default()(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return __jsx("div", {
    className: classnames_default()(thRoot, 'relative', {
      'transform -scale-x-1': isRTL
    }, className),
    dir: "ltr",
    id: id
  }, __jsx("div", {
    className: classnames_default()('h-full', thInner)
  }, __jsx("div", {
    className: scrollAreaClassName
  }, __jsx("div", {
    className: classnames_default()('flex flex-row flex-nowrap w-full', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return __jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: classnames_default()(isFunction_default()(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, (_classnames = {
        'snap-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, 'transform -scale-x-1', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null, {
      style: scrollItemStyle
    }), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr'
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && __jsx("div", {
    className: classnames_default()(scrollControlsClassName, thControls)
  }, __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}

/***/ }),

/***/ "gz38":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "timeout", undefined);

    _defineProperty(_assertThisInitialized(_this), "container", undefined);

    _defineProperty(_assertThisInitialized(_this), "content", undefined);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      clearTimeout(_this.timeout);

      if (!_this.container || !_this.content) {
        return;
      }

      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          checkTimeout = _this$props.checkTimeout;
      var containerHeight = Math.floor(_this.container.clientHeight);
      var contentHeight = Math.floor(_this.content.clientHeight);
      var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
      var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;

      if (isFullyOpened || isFullyClosed) {
        _this.onRest({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      } else {
        _this.onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });

        _this.timeout = setTimeout(function () {
          return _this.onResize();
        }, checkTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref) {
      var isFullyOpened = _ref.isFullyOpened,
          isFullyClosed = _ref.isFullyClosed,
          isOpened = _ref.isOpened,
          containerHeight = _ref.containerHeight,
          contentHeight = _ref.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var hasClosed = !isOpened && _this.container.style.height === '0px';

      if (hasOpened || hasClosed) {
        _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
        _this.container.style.height = isOpened ? 'auto' : '0px';
        var onRest = _this.props.onRest;

        if (onRest) {
          onRest({
            isFullyOpened: isFullyOpened,
            isFullyClosed: isFullyClosed,
            isOpened: isOpened,
            containerHeight: containerHeight,
            contentHeight: contentHeight
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref2) {
      var isFullyOpened = _ref2.isFullyOpened,
          isFullyClosed = _ref2.isFullyClosed,
          isOpened = _ref2.isOpened,
          containerHeight = _ref2.containerHeight,
          contentHeight = _ref2.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var isClosing = !isOpened && _this.container.style.height === '0px';

      if (isOpenining || isClosing) {
        // No need to do any work
        return;
      }

      _this.container.style.overflow = 'hidden';
      _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
      var onWork = _this.props.onWork;

      if (onWork) {
        onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContainer", function (container) {
      _this.container = container;
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContent", function (content) {
      _this.content = content;
    });

    if (props.initialStyle) {
      _this.initialStyle = props.initialStyle;
    } else {
      _this.initialStyle = props.isOpened ? {
        height: 'auto',
        overflow: 'initial'
      } : {
        height: '0px',
        overflow: 'hidden'
      };
    }

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          isOpened = _this$props2.isOpened,
          children = _this$props2.children;
      return children !== nextProps.children || isOpened !== nextProps.isOpened || Object.keys(theme).some(function (c) {
        return theme[c] !== nextProps.theme[c];
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      if (!this.container || !this.content) {
        return null;
      }

      if (this.container.style.height === 'auto') {
        var contentHeight = this.content.clientHeight;
        this.container.style.height = "".concat(contentHeight, "px");
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theme = _this$props3.theme,
          children = _this$props3.children,
          isOpened = _this$props3.isOpened;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContainer,
        className: theme.collapse,
        style: this.initialStyle,
        "aria-hidden": !isOpened
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContent,
        className: theme.content
      }, children));
    }
  }]);

  return Collapse;
}(_react["default"].Component);

exports.Collapse = Collapse;

_defineProperty(Collapse, "defaultProps", {
  theme: {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
  },
  initialStyle: undefined,
  onRest: undefined,
  onWork: undefined,
  checkTimeout: 50
});

/***/ }),

/***/ "mmhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Countdown_Countdown; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("Jhhs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.themes.js





var defaultValueSizes = {
  small: {
    w: '2.3rem',
    valueTextSize: 'text-16',
    labelTextSize: 'text-8'
  },
  large: {
    w: '3.0625rem',
    valueTextSize: 'text-24',
    labelTextSize: 'text-10'
  }
};
var themes = {
  "default": memoize_default()(function (_ref) {
    var size = _ref.size,
        color = _ref.color;
    var textColor = color ? color : colors["a" /* COLORS */].WHITE;
    var textShadow = textColor === colors["a" /* COLORS */].WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thItem: "flex flex-col items-center justify-between mx-5 text-center text-".concat(textColor),
      thValuesWrapper: 'flex flex-row',
      thLabel: "font-bold leading-1 mb-5 ".concat(textShadow, " uppercase ").concat(defaultValueSizes[size].labelTextSize),
      thValue: "flex font-bold items-center justify-center rounded-4 text-center ".concat(textShadow, " leading-tight ").concat(defaultValueSizes[size].valueTextSize),
      thValueStyle: {
        width: defaultValueSizes[size].w
      }
    };
  }),
  timer: memoize_default()(function (_ref2) {
    var size = _ref2.size,
        color = _ref2.color;
    return {
      thRoot: 'flex items-stretch justify-center text-14 mb-15',
      thDescription: "bg-".concat(color, " text-white shadow-sm py-5 px-10 mr-10 items-baseline"),
      thItem: "flex flex-row items-center justify-between text-center text-".concat(color),
      thLabel: 'items-baseline',
      thValuesWrapper: 'flex flex-row shadow-sm py-5 px-10 w-[7.5rem] justify-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  offerPush: function offerPush(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref3$color,
        bgColor = _ref3.bgColor;
    return {
      thRoot: classnames_default()("font-sans font-bold px-10 py-5 rounded-pill text-12 text-".concat(color), Object(defineProperty["a" /* default */])({}, "bg-".concat(bgColor), !!bgColor)),
      thItem: "inline mx-1 text-center text-".concat(color, " uppercase"),
      thValuesWrapper: 'flex flex-row py-1',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: 'auto'
      }
    };
  },
  infoBanner: function infoBanner() {
    return {
      thRoot: 'font-brand px-5 rounded-2',
      thItem: 'flex mx-1 text-center text-14 uppercase',
      thValuesWrapper: 'flex flex-row',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: '20px'
      }
    };
  },
  push: memoize_default()(function (_ref4) {
    var color = _ref4.color;
    return {
      thRoot: "font-brand text-".concat(color, " text-18 uppercase"),
      thValuesWrapper: 'flex',
      thItem: 'flex items-center leading-1 mx-2'
    };
  }),
  options: memoize_default()(function (_ref5) {
    var size = _ref5.size,
        color = _ref5.color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thDescription: 'font-bold text-saffron py-5 items-baseline',
      thItem: "flex flex-row items-baseline justify-between text-center text-".concat(color),
      thLabel: 'items-baseline text-14',
      thValuesWrapper: 'flex flex-row font-bold text-14 items-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5 text-14',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  optionDetails: memoize_default()(function (_ref6) {
    var size = _ref6.size,
        _ref6$color = _ref6.color,
        color = _ref6$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref6$color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thDescription: 'font-bold text-black py-5 items-baseline',
      thItem: "flex flex-col items-center text-".concat(color, " bg-pearl p-5 ml-5"),
      thLabel: 'items-baseline text-10 text-black',
      thValuesWrapper: 'flex flex-row font-bold text-18 items-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5 text-18',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx







var __jsx = react_default.a.createElement;





function calculateTimeLeft(dateTimeEnd) {
  var now = moment_default()();
  return now.isBefore(dateTimeEnd) ? moment_default.a.duration(moment_default()(dateTimeEnd).diff(now)) : moment_default.a.duration(0);
}

function resolveTime(unit, roundToUnit, timeRemaining) {
  if (roundToUnit === unit) {
    switch (roundToUnit) {
      case 'days':
        return Math.floor(timeRemaining.asDays()).toString();

      case 'hours':
        return Math.floor(timeRemaining.asHours()).toString();

      case 'minutes':
        return Math.floor(timeRemaining.asMinutes()).toString();

      case 'seconds':
        return Math.floor(timeRemaining.asSeconds()).toString();

      default:
        return Math.floor(timeRemaining.asSeconds()).toString();
    }
  }

  return timeRemaining.get(unit).toString();
}

var Countdown_Countdown = function Countdown(_ref) {
  var bgColor = _ref.bgColor,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      dateTimeEnd = _ref.dateTimeEnd,
      description = _ref.description,
      expiredRender = _ref.expiredRender,
      _ref$roundToUnit = _ref.roundToUnit,
      roundToUnit = _ref$roundToUnit === void 0 ? 'days' : _ref$roundToUnit,
      _ref$showTimer = _ref.showTimer,
      showTimer = _ref$showTimer === void 0 ? true : _ref$showTimer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$units = _ref.units,
      units = _ref$units === void 0 ? ['days', 'hours', 'minutes', 'seconds'] : _ref$units,
      _ref$updateFrequency = _ref.updateFrequency,
      updateFrequency = _ref$updateFrequency === void 0 ? 300 : _ref$updateFrequency,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["bgColor", "className", "color", "dataTestId", "dateTimeEnd", "description", "expiredRender", "roundToUnit", "showTimer", "size", "theme", "units", "updateFrequency"]);

  var _useState = Object(react["useState"])(calculateTimeLeft(dateTimeEnd)),
      timeRemaining = _useState[0],
      setTimeRemaining = _useState[1];

  Object(react["useEffect"])(function () {
    var timer = setTimeout(function () {
      if (dateTimeEnd && timeRemaining.asSeconds() > 0) {
        setTimeRemaining(calculateTimeLeft(dateTimeEnd));
      }
    }, updateFrequency);
    return function () {
      return clearTimeout(timer);
    };
  }, [timeRemaining, dateTimeEnd]);
  var shouldDisplay = timeRemaining.asSeconds() > 0 && timeRemaining.months() === 0;

  if (!shouldDisplay) {
    if (dateTimeEnd && !!expiredRender) {
      return expiredRender;
    }

    return null;
  }

  if (!showTimer) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    size: size,
    bgColor: bgColor
  }),
      thItem = _themes$theme.thItem,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thValue = _themes$theme.thValue,
      thDescription = _themes$theme.thDescription,
      thValueStyle = _themes$theme.thValueStyle,
      thValuesWrapper = _themes$theme.thValuesWrapper;

  return __jsx("div", {
    className: classnames_default()(thRoot, className),
    role: "timer",
    "data-testid": dataTestId
  }, description && __jsx("div", {
    className: thDescription
  }, description), __jsx("div", {
    className: thValuesWrapper
  }, units.map(function (unit) {
    var currentTime = resolveTime(unit, roundToUnit, timeRemaining);
    var transformedCurrentTime = currentTime.padStart(2, '0');
    return __jsx("div", {
      className: thItem,
      key: unit
    }, __jsx("div", {
      className: thValue,
      style: thValueStyle
    }, transformedCurrentTime), __jsx("div", {
      className: thLabel
    }, " ", props[unit]));
  })));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ })

}]);